import { useState, type FormEvent } from "react";
import { login, ApiError } from "../api";

interface LoginPageProps {
  onLoginSuccess: () => void;
}

export default function LoginPage({ onLoginSuccess }: LoginPageProps) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError(null);
    setIsSubmitting(true);
    try {
      await login(username, password);
      onLoginSuccess();
    } catch (err) {
      const message = err instanceof ApiError ? err.message : "Anmeldung fehlgeschlagen";
      setError(message);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="page-center">
      <form className="login-card" onSubmit={handleSubmit}>
        <h1>Fortuna Softec</h1>
        <p className="subtitle">Login-Portal</p>

        <label htmlFor="username">Benutzername</label>
        <input
          id="username"
          name="username"
          type="text"
          autoComplete="username"
          value={username}
          onChange={(event) => setUsername(event.target.value)}
          required
        />

        <label htmlFor="password">Passwort</label>
        <div className="password-field">
          <input
            id="password"
            name="password"
            type={showPassword ? "text" : "password"}
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
          <button
            type="button"
            className="password-toggle"
            aria-label={showPassword ? "Passwort verbergen" : "Passwort anzeigen"}
            onClick={() => setShowPassword((visible) => !visible)}
          >
            {showPassword ? "Verbergen" : "Anzeigen"}
          </button>
        </div>

        {error && (
          <p className="error-message" role="alert">
            {error}
          </p>
        )}

        <button type="submit" className="primary-button" disabled={isSubmitting}>
          {isSubmitting ? "Anmelden..." : "Anmelden"}
        </button>
      </form>
    </div>
  );
}
